<!-- Enterprise Admin Bar - Matches admin header style -->
<nav class="navbar navbar-expand navbar-dark enterprise-bar" [style.background-color]="backgroundColor">
    <div class="container-fluid">
        <ul class="navbar-nav me-auto">
            <!-- Enterprise Selector Dropdown -->
            <li class="nav-item dropdown" *ngIf="canSwitchEnterprise">
                <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button" aria-expanded="false">
                    <i class="fa-solid fa-building"></i>
                    {{ enterpriseContext.currentEnterpriseDisplayName }}
                </a>
                <ul class="dropdown-menu">
                    <li>
                        <a class="dropdown-item" [class.active]="!isEnterpriseSelected" (click)="onEnterpriseSelect(null)" href="javascript:void(0)">
                            <i class="fa-solid fa-globe"></i> All Enterprises
                        </a>
                    </li>
                    <li><hr class="dropdown-divider" /></li>
                    <li *ngFor="let enterprise of availableEnterprises">
                        <a class="dropdown-item" [class.active]="enterpriseContext.isEnterpriseSelected(enterprise.key)" (click)="onEnterpriseSelect(enterprise.key)" href="javascript:void(0)">
                            <span class="enterprise-dot" [style.background-color]="enterprise.primaryColor"></span>
                            {{ enterprise.name }}
                        </a>
                    </li>
                </ul>
            </li>

            <!-- Enterprise Badge (for enterprise managers - no dropdown, no lock icon) -->
            <li class="nav-item" *ngIf="!canSwitchEnterprise">
                <span class="nav-link">
                    <i class="fa-solid fa-building"></i>
                    {{ enterpriseContext.currentEnterpriseDisplayName }}
                </span>
            </li>

            <!-- Menu Items -->
            <li class="nav-item" *ngFor="let item of menuItems">
                <a class="nav-link" [routerLink]="[item.route]" routerLinkActive="active"> <i [class]="item.icon"></i> {{ item.label }} </a>
            </li>

            <!-- Tools Dropdown -->
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button" aria-expanded="false">
                    <i class="fa-solid fa-wrench"></i> Tools
                </a>
                <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                        <a class="dropdown-item" routerLink="/admin/tools/api" routerLinkActive="active">
                            <i class="fa-solid fa-code me-2"></i> API Management
                        </a>
                    </li>
                    <li *ngIf="authService.isAdmin">
                        <a class="dropdown-item" routerLink="/admin/tools/migrate-parking" routerLinkActive="active">
                            <i class="fa-solid fa-truck-moving me-2"></i> Migrate Parking
                        </a>
                    </li>
                    <li *ngIf="authService.isAdmin">
                        <a class="dropdown-item" routerLink="/admin/tools/redefine-importer" routerLinkActive="active">
                            <i class="fa-solid fa-file-import me-2"></i> Redefine Parking Importer
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</nav>
